import DefaultImage from "../../../assets/images/Default.png";

function ProductImage({ src }) {
  const imgUrl = src || DefaultImage;
  return <img style={{ width: "100px" }} src={imgUrl} alt="product" />;
}

export default ProductImage;
